import React from 'react';

function NoMatch_404() {
    return <h2>このページは存在しません。</h2>;
  }
  
  export default NoMatch_404;